import { render, staticRenderFns } from "./TableRow.vue?vue&type=template&id=2f99fdce&scoped=true"
import script from "./TableRow.vue?vue&type=script&lang=ts"
export * from "./TableRow.vue?vue&type=script&lang=ts"
import style0 from "./TableRow.vue?vue&type=style&index=0&id=2f99fdce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f99fdce",
  null
  
)

export default component.exports